import axios from 'axios';
import store from '@/store/index';
import {Guid} from "@/utils/methods";

const ajax = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL + "/auth/v1",
});
ajax.interceptors.request.use((config) => {
    // 如果 token 存在
    const token = store.getters['account/token']();
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
});

// 获取token
export const login = (params) => {
    params.terminalCode = Guid();
    return new Promise((resolve, reject) => {
        ajax.post('/login', params).then(res => {
            if(!res.data.isSuccess){
                return resolve(res)
            }
            const data = res.data.data;
            store.commit("account/setToken", data.accessToken);
            store.commit("account/setUser", {
                ...data.user,
                terminalCode: params.terminalCode,
            });
            localStorage.setItem("refresh_token_time", Date.now() + (data.expiresIn * 1000));
            localStorage.setItem("refresh_token", data.refreshToken);
            resolve(res);
        }).catch(reject);
    });
};

export const refreshToken = () => {
    const token = store.getters['account/token']();
    const time = Number(localStorage.getItem("refresh_token_time")) || 0;
    if (!token || !time || Date.now() > time || time - 10 * 60 * 1000 > Date.now()) {
        return Promise.reject();
    }
    return new Promise(function (resolve, reject) {
        ajax.post('/refreshLogin', {
            applicationId: 1,
            loginMode: 1,
            userId: store.getters["account/user"].id,
            refreshToken: localStorage.getItem("refresh_token"),
            terminalCode: store.getters["account/user"].terminalCode,
        }).then(res => {
            const data = res.data.data;
            store.commit("account/setToken", data.accessToken);
            localStorage.setItem("refresh_token_time", Date.now() + (data.expiresIn * 1000));
            localStorage.setItem("refresh_token", data.refreshToken);
            resolve(res);
        }).catch(reject);
    });
};

export const logout = () => {
    return new Promise(function (resolve, reject) {
        ajax.post('/logout', {
            userId: store.getters["account/user"].id,
            loginMode: 1,
            terminalCode: store.getters["account/user"].terminalCode,
        }).finally(() => {
            store.commit("account/setToken", "");
            store.commit("account/setRoutesConfig", []);
            store.commit("account/setUser", "");
        });
        resolve();
    });
};
